export default __webpack_public_path__ + "static/rsz_tomasz_bogus_v2-e4b1882cba277a08a68361409404a443.jpg";